import { defineDocument } from '../../schema';
export const blogTooManyCooksHitsTheKitchenDocument = defineDocument({
    id: 'blog:too-many-cooks-hits-the-kitchen',
    kind: 'blog',
    slug: 'too-many-cooks-hits-the-kitchen',
    route: '/blog/too-many-cooks-hits-the-kitchen',
    seo: {
        title: 'Too Many Cooks Hits the Kitchen',
        description: 'A crazy three-course cook-off where survey answers become ingredients and the best dish wins',
        imageAsset: 'coverTooManyCooks',
    },
    hero: {
        eyebrow: [
            {
                type: 'text',
                text: 'Airhead Blog',
            },
        ],
        title: [
            {
                type: 'text',
                text: 'Too Many Cooks Hits the Kitchen',
            },
        ],
        description: [
            {
                type: 'text',
                text: 'A crazy three-course cook-off where survey answers become ingredients and the best dish wins',
            },
        ],
        imageAsset: 'coverTooManyCooks',
        imageAlt: 'Too Many Cooks cover art',
        showDescription: true,
        background: 'blurred-image',
    },
    meta: {
        author: 'Jay',
        publishedAt: new Date('2026-01-06T00:00:00.000Z'),
        tags: ['games'],
    },
    sections: [
        {
            id: 'article',
            blocks: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: "The kitchen is open, and it's already too loud. ",
                        },
                        {
                            type: 'link',
                            href: '/discover/games/too-many-cooks',
                            children: [
                                {
                                    type: 'text',
                                    text: 'Too Many Cooks',
                                },
                            ],
                        },
                        {
                            type: 'text',
                            text: ' is our three-course party game where a simple survey turns into a pantry of questionable ingredients.',
                        },
                    ],
                },
            ],
            sections: [
                {
                    id: 'article__how-it-plays',
                    title: [
                        {
                            type: 'text',
                            text: 'How It Plays',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Over three rounds, the group will cook an appetizer, a main dish, and a dessert. Each round starts with five Chef Survey questions to stock the pantry. Each chef will take three ingredients to name their dish. You can repeat ingredients and even use your own if it helps your recipe.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Once the dishes are named, everyone votes for the best, and an image of the winning dish is revealed. Points stack in two ways: 25 every time your ingredient is used and 100 for each vote your dish receives.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__absurdity-by-design',
                    title: [
                        {
                            type: 'text',
                            text: 'Absurdity by Design',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'The feeling we were chasing was simple: absurdity. Everyone is contributing, but nobody is fully sure how the chaotic cooking process will turn out. The rules are clear, yet the outcomes live right on the edge of making sense.',
                                },
                            ],
                        },
                        {
                            type: 'quote',
                            content: [
                                {
                                    type: 'text',
                                    text: 'The game structure is simple, but I wanted the name of every dish to live on the borderline of making sense.',
                                },
                            ],
                            attribution: [
                                {
                                    type: 'text',
                                    text: 'Jay, Developer',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'The hardest design challenge was figuring out how players would create a bountiful and diverse assortment of ingredients. The Chef Survey solved it. We guide players toward answers that include different parts of speech and a wide variety of edible and inedible things.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__recipe-for-success',
                    title: [
                        {
                            type: 'text',
                            text: 'Recipe for Success',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'There is no perfect recipe for a winning dish. The best rounds are the ones where an improbable combination of unrelated words produces a dish that, dare I say, looks tasty. The most entertaining outcome is the most likely. Chefs who creatively combine ingredients into funny, absurd dishes will rise to the top.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__ready-chefs',
                    title: [
                        {
                            type: 'text',
                            text: 'Ready Chefs?',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'The first couple playthroughs by Twitch streamers resulted in dishes way more hilarious than anything we cooked up while developing the game. What wild dishes did you create? Share them in ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://discord.gg/rfFTVAqHwH',
                                    children: [
                                        {
                                            type: 'text',
                                            text: "Poppy's Pals Discord",
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: '.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Hop in the kitchen to ',
                                },
                                {
                                    type: 'link',
                                    href: '/library',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'play Too Many Cooks now.',
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'article-actions',
            widgets: [
                {
                    type: 'relatedDocuments',
                    limit: 4,
                },
            ],
        },
    ],
});
//# sourceMappingURL=too-many-cooks-hits-the-kitchen.js.map